import { render, staticRenderFns } from "./kuran-paragraph.vue?vue&type=template&id=38c14ee8&scoped=true&"
import script from "./kuran-paragraph.vue?vue&type=script&lang=js&"
export * from "./kuran-paragraph.vue?vue&type=script&lang=js&"
import style0 from "./kuran-paragraph.vue?vue&type=style&index=0&id=38c14ee8&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c14ee8",
  null
  
)

export default component.exports